import Page from '@/gf/components/Page'
import SideNav from '@/gf/components/SideNav'
import * as api from '@/suppliers/modules/api'
import {
  BellIcon,
  Cog6ToothIcon,
  TruckIcon,
  UserCircleIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline'
import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { SideNavSection, Store, User } from '../../types'
import Frame from '../components/Frame'
import useSession from '../hooks/useSession'
import NotificationSettings from './Settings/Notifications'
import Profile from './Settings/Profile'
import Shipping from './Settings/Shipping'
import StoreSettings from './Settings/Store'
import UsersSettings from './Settings/Users'

const sections: SideNavSection[] = [
  {
    title: 'User',
    links: [
      { title: 'Profile', to: '/settings/profile', icon: UserCircleIcon },
      { title: 'Notifications', to: '/settings/notifications', icon: BellIcon },
    ],
  },
  {
    title: 'Organization',
    links: [
      { title: 'Store', to: '/settings/store', icon: Cog6ToothIcon },
      { title: 'Users', to: '/settings/users', icon: UserGroupIcon },
      { title: 'Shipping', to: '/settings/shipping', icon: TruckIcon },
    ],
  },
]

const Settings = () => {
  const loc = useLocation()
  const { user, store } = useSession()
  const [activeUser, setActiveUser] = React.useState<User>()
  const [activeStore, setActiveStore] = React.useState<Store>()

  React.useEffect(() => {
    api.fetchUser(user.id).then(setActiveUser)
    api.fetchStore(store.id).then(setActiveStore)
  }, [user, store])

  if (!activeUser || !activeStore) return null

  return (
    <Frame>
      <Page title="Settings">
        <div className="mt-8 flex flex-wrap md:flex-nowrap gap-8">
          <div className="shrink-0">
            <SideNav sections={sections} locationPathname={loc.pathname} />
          </div>
          <div className="overflow-x-auto grow">
            <Routes>
              <Route path="" element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<Profile activeUser={activeUser} />} />
              <Route path="store" element={<StoreSettings activeStore={activeStore} />} />
              <Route path="users" element={<UsersSettings store={activeStore} />} />
              <Route path="notifications" element={<NotificationSettings userId={user.id} />} />
              <Route path="shipping" element={<Shipping activeStore={activeStore} />} />
            </Routes>
          </div>
        </div>
      </Page>
    </Frame>
  )
}

export default Settings
